import { BulkImportDto } from './configs/bulk-import.dto';
import { BulkImportConfigDto } from './configs/bulk-import/bulk-import-data.dto';
import { ProspectSearchDto } from './configs/prospect-search.dto';
import { ProspectSearchFiltersDto } from './configs/prospect-search/prospect-search-filters.dto';

export enum SourceClasses {
    PROSPECT_SEARCH = 'PROSPECT_SEARCH',
    BULK_IMPORT = 'BULK_IMPORT',
}

export type SourceConfig = ProspectSearchFiltersDto | BulkImportConfigDto;

export class SourceTypeDto {
    class: SourceClasses;
    config: SourceConfig; // type-specific

    constructor(iSourceType: SourceTypeDto) {
        this.class = iSourceType.class;
        this.config = iSourceType.config;
    }

    static fromDocument<T extends SourceTypeDto = SourceTypeDto>(iSourceType: T): T {
        switch (iSourceType.class) {
            case SourceClasses.PROSPECT_SEARCH: {
                const prospectSearchDto = ProspectSearchDto.fromDocument(iSourceType as ProspectSearchDto);
                return prospectSearchDto as T;
            }
            case SourceClasses.BULK_IMPORT: {
                const bulkImportDto = BulkImportDto.fromDocument(iSourceType as BulkImportDto);
                return bulkImportDto as T;
            }
        }
    }
}

export interface ISourceType {
    class: SourceClasses;
    config: any; // type-specific
}
